import { useEffect, useRef, useState } from "react";

/**
 * The Android back button closes the topmost layer: a menu, a dialog, a picker, an editor, the exercise page, else
 * the App's own handler (other tab → Workout tab, Workout tab → app into the background). Each layer registers its
 * close action with `useBack`. The order is the order in which the layers were first rendered (a parent renders
 * before its children), so a dialog opened on a screen lies above that screen.
 */
let seq = 0;
const layers = new Map<number, { current: () => void }>();

/** Registers `onBack` as this component's back action while `active`. */
export function useBack(onBack: () => void, active = true) {
  const [id] = useState(() => ++seq);
  const action = useRef(onBack);
  action.current = onBack;
  useEffect(() => {
    if (!active) return;
    layers.set(id, action);
    return () => { layers.delete(id); };
  }, [id, active]);
}

/** Runs the topmost layer's back action; false when no layer is registered. */
export function goBack(): boolean {
  if (layers.size === 0) return false;
  layers.get(Math.max(...layers.keys()))!.current();
  return true;
}
